
    import { Vue,Component } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import PagedTable from '../../components/common/pagedTable.vue'
    const customer = namespace('customer')
    @Component({
        components: {
            PagedTable,
        }
    })
    export default class Home extends Vue{
        search:any = {
            nickname: '',
            bondphones: '',
            bindtype: '0',
            pageSize: 20,
            page: 1
        }
        @customer.State('pager') pager:any //表格的页码
        @customer.State('list') pagerList:any //快递员列表
        get tablecolumn(){
            return [
                {
                    prop: 'headimgurl',
                    type: 'image',
                    label: '头像',

                },
                {
                    prop: 'nickname',
                    type: 'text',
                    label: '昵称',

                },
                {
                    prop: 'subscribe_time',
                    type: 'text',
                    label: '关注时间',

                },
                {
                    prop: 'adress',
                    name: 'adress',
                    type: 'slot',
                    label: '地址',

                },
                {
                    prop: 'bondphones',
                    name: 'bondphones',
                    type: 'slot',
                    label: '手机',

                },
                {
                    prop: 'operation',
                    name: 'operation',
                    type: 'slot',
                    label: '操作',

                }
            ]
        }
        @customer.Action('getCustomerList') getCustomerList:any
        @customer.Action('bindPhone') bindPhone:any
        
        mounted(){
            this.getList()
        }
        getList(){
            this.getCustomerList(this.search)
        }
        // 翻页
        pagechange(e:any){
            this.search.page = e[0].val
            this.getList()
        }
        // 绑定微信
        bindWx(id:string){
            this.$prompt('请输入电话号码', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^(\+?0?86\-?)?1[3456789]\d{9}$/,
                inputErrorMessage: '电话号码格式不正确'
            }).then(async ({ value }) => {
                const res = await this.bindPhone({
                    id: id,
                    data: {
                        phone: value
                    }
                })
                if(res){
                    this.$message({
                        type: 'success',
                        message: '绑定成功'
                    });
                    this.getList()
                }
            })
        }
    }
